import { IRichMarkdownRef } from "lucy/common-components";
import * as React from "react";
import { Button, Input, Label, Modal } from "uxp/components";
import { isNone } from "../../../util";
import { IUIPropertyDefinition } from '../common';

interface HTMLCodeTextFieldProps {
    html: string;
    onChangeHtml: (html: string) => void
}

export const HTMLCodeTextField: React.FunctionComponent<HTMLCodeTextFieldProps> = (props) => {
    const [showEditor, setShowEditor] = React.useState<boolean>(false)
    const textAreaRef = React.useRef<any>();

    React.useEffect(() => { if (textAreaRef.current) {
        textAreaRef.current.value = props.html
    } }, [showEditor])


    function fixTabError(e: React.KeyboardEvent) {
        if (e.key == 'Tab') {
            e.preventDefault();
            const t = (e.target as any)
            var start = t.selectionStart;
            var end = t.selectionEnd;

            const r = t.value.substring(0, start) + "\t" + t.value.substring(end)

            t.value = r
            props.onChangeHtml(r)

            t.selectionStart = t.selectionEnd = start + 1;
        }
    }

    return <div className='wd-prop-item'>

        <Modal
            show={showEditor}
            onClose={() => { setShowEditor(false) }}
            title={'Edit HTML'}
        >
            <div className="content">
                <textarea rows={30}
                    style={{fontSize: '14px'}}
                    ref={textAreaRef}
                    onChange={e => props.onChangeHtml(e.target.value)}
                    className="uxp-form-input"
                    onKeyDown={fixTabError}
                />
            </div>

        </Modal>

        <div className='wd-prop-item-title'>{'Text Field'}</div>
        <div className='wd-prop-item-editor'>
            <Label>HTML Code</Label>
            <textarea 
                rows={10}
                value={props.html || ''}
                style={{fontSize: '10px'}}
                onChange={e => props.onChangeHtml(e.target.value)}
                className="uxp-form-input"
            />

            <Button title={'Show editor'} onClick={() => { setShowEditor(true) }}
                icon="/Resources/Lucy/lucy-dashboard/assets/images/uxp-card.svg"
                iconPosition="right" />
        </div>

    </div>;
}


export function HTMLCodeProperty(title: string, defaultProps: string): IUIPropertyDefinition<string> {

    return {
        defaults: defaultProps,
        render: (props) => {

            console.log('these are ui props', props)
            return <HTMLCodeTextField
                html={isNone(props.uiProps) ? defaultProps : props.uiProps}
                onChangeHtml={s => props.onChange(s)}
            />
        }
    };
}